import { RESET_ADVANCE_APPLICATION, UPDATE_ADVANCE_APPLICATION } from '../../../actions/CXP/Entry/AdvanceApplication';
import { initialAdvanceApplicationState, reduceAdvanceApplication } from '../../../../util/advanceApplicationReducer';

export default function CXPAdvanceApplication(state = initialAdvanceApplicationState(), action) {
  return reduceAdvanceApplication(state, action, RESET_ADVANCE_APPLICATION, UPDATE_ADVANCE_APPLICATION);
}
